import { toast } from "react-toastify";
import { onAddEmployee, onGetOrgemployees } from "../services/employee";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default () => {
  const { setLoading } = useStateSetter();
  const [selectedOrgEmployees, setselectedOrgEmployess] = useState<any[]>([]);
  const { SelectedOrg, config } = useStateGetter();
  const {orgid}=useParams()

  const getOrgEmployees = async () => {

    setLoading(true);
    try {
      var res = await onGetOrgemployees(SelectedOrg.id??orgid, config);
      setselectedOrgEmployess(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.log(e);
      toast.error(e);
    }
  };
  const refresh = async () => {
    await getOrgEmployees();
  };
  const AddEmployee = async (postData: any) => {
    try {
      var response = await onAddEmployee(postData, config);

      if (response.success) {
        toast.success(response.message);

        setLoading(false);
      }
      setLoading(false);
    } catch (e: any) {
      console.log(e);
      toast.error(e);
      //setLoading(false);
    }
  };

  useEffect(() => {
    getOrgEmployees();
  }, [SelectedOrg?.id]);
  return { AddEmployee, refresh, selectedOrgEmployees };
};
